var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavbarAbcLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 24,
    viewBox: "0 0 55 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3239 16.8597H49.1971C48.3139 18.0568 46.8771 18.8224 45.2674 18.7701C42.7832 18.6902 40.7726 16.6403 40.7363 14.1547C40.6985 11.5382 42.8152 9.39832 45.4229 9.39832C47.1807 9.39832 48.7134 10.3702 49.5153 11.8055H54.3254C54.7104 11.8055 54.9791 11.4307 54.8614 11.0646C53.5816 7.07246 49.8334 4.1742 45.4214 4.1742C45.1512 4.1742 44.8839 4.18583 44.6195 4.20616C44.5163 4.21197 44.4059 4.22069 44.2912 4.23231C41.2927 4.57226 38.6951 6.25601 37.1174 8.66468C35.3451 5.964 32.2914 4.17711 28.828 4.17711C27.1341 4.17711 25.5375 4.60422 24.1414 5.35675V3.48995C24.1414 -0.426683 18.9173 0.0149552 18.9173 0.0149552V9.72084C18.4335 8.73877 17.7929 7.84823 17.0272 7.08263C15.2331 5.28847 12.7547 4.17711 10.022 4.17711C7.28941 4.17711 4.81245 5.28847 3.01685 7.08263C1.22269 8.87824 0.111328 11.3552 0.111328 14.0878C0.111328 16.8205 1.22269 19.2974 3.01685 21.093C4.811 22.8872 7.28941 23.9985 10.022 23.9985C11.9673 23.9985 13.7847 23.4349 15.3174 22.4615C16.6946 24.2571 19.9328 23.984 19.9328 23.984V18.4548C21.5497 21.7351 24.9288 23.9985 28.828 23.9985C32.2972 23.9985 35.3538 22.2044 37.1247 19.4979C37.1247 19.4979 37.1247 19.4979 37.1247 19.4994C38.839 22.1129 41.7532 23.8751 45.0698 23.9913C49.5022 24.1453 53.3215 21.3705 54.7409 17.4553C54.8455 17.1662 54.6305 16.8597 54.3225 16.8597H54.3239ZM10.022 18.7744C8.73055 18.7744 7.55817 18.2485 6.70976 17.4001C5.86135 16.5517 5.33545 15.3793 5.33545 14.0878C5.33545 12.7963 5.86135 11.6239 6.70976 10.7755C7.55817 9.92713 8.73055 9.40123 10.022 9.40123C11.3135 9.40123 12.4859 9.92713 13.3343 10.7755C14.1827 11.6239 14.7086 12.7963 14.7086 14.0878V15.7294L13.3343 17.4001C12.4859 18.2485 11.3135 18.7744 10.022 18.7744V18.7744ZM32.1403 17.4001C31.2919 18.2485 30.1195 18.7744 28.828 18.7744C27.5365 18.7744 26.3641 18.2485 25.5157 17.4001C24.6673 16.5517 24.1414 15.3793 24.1414 14.0878V12.4448L25.5157 10.7741C26.3641 9.92568 27.5365 9.39978 28.828 9.39978C30.1195 9.39978 31.2919 9.92568 32.1403 10.7741C32.9887 11.6225 33.5146 12.7949 33.5146 14.0864C33.5146 15.3779 32.9887 16.5503 32.1403 17.3987V17.4001Z",
    fill: "url(#paint0_linear_13350_116678)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0219 23.7213C7.36627 23.7213 4.9576 22.6405 3.21429 20.8972C1.46952 19.1524 0.388672 16.7437 0.388672 14.0881C0.388672 11.4324 1.46952 9.02376 3.21283 7.279C4.9576 5.53423 7.36482 4.45483 10.0205 4.45483C12.6761 4.45483 15.0848 5.53569 16.8281 7.279C18.5729 9.02376 19.6523 11.431 19.6523 14.0881C19.6523 16.7452 18.5714 19.1524 16.8281 20.8957C15.0833 22.6405 12.6761 23.7199 10.0205 23.7199L10.0219 23.7213ZM10.0219 9.124C8.65342 9.124 7.41276 9.68041 6.5135 10.5797C5.61425 11.4789 5.05784 12.7196 5.05784 14.0881C5.05784 15.4566 5.61425 16.6972 6.5135 17.5965C7.41276 18.4957 8.65342 19.0522 10.0219 19.0522C11.3904 19.0522 12.6311 18.4957 13.5303 17.5965C14.4296 16.6972 14.986 15.4566 14.986 14.0881C14.986 12.7196 14.4296 11.4789 13.5303 10.5797C12.6311 9.68041 11.3904 9.124 10.0219 9.124V9.124Z",
    fill: "url(#paint1_linear_13350_116678)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8286 23.7212C23.5173 23.7212 19.1953 19.3993 19.1953 14.088C19.1953 13.9936 19.1968 13.8991 19.1997 13.8062L19.2084 13.52H19.1953V0.280982C19.2505 0.280982 19.3144 0.278076 19.3842 0.278076C20.7309 0.278076 23.863 0.591872 23.863 3.49158V5.82326L24.2727 5.60244C25.6644 4.85136 27.2407 4.45476 28.8271 4.45476C34.1384 4.45476 38.4603 8.77671 38.4603 14.088C38.4603 19.3993 34.1384 23.7212 28.8271 23.7212H28.8286ZM28.8286 9.12392C26.0916 9.12392 23.8645 11.351 23.8645 14.088C23.8645 16.825 26.0916 19.0521 28.8286 19.0521C31.5656 19.0521 33.7926 16.825 33.7926 14.088C33.7926 11.351 31.5656 9.12392 28.8286 9.12392V9.12392Z",
    fill: "url(#paint2_linear_13350_116678)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1406 5.35689V12.4449L25.5149 10.7742C26.3633 9.92581 27.5357 9.39991 28.8272 9.39991V4.17725C27.1333 4.17725 25.5367 4.60436 24.1406 5.35689V5.35689Z",
    fill: "url(#paint3_linear_13350_116678)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7081 20.5093V15.7312L13.3338 17.4019C12.4854 18.2503 11.313 18.7762 10.0215 18.7762V24.0003C11.9667 24.0003 13.7841 23.4366 15.3168 22.4633C14.9449 21.9781 14.7081 21.3432 14.7081 20.5108V20.5093Z",
    fill: "url(#paint4_linear_13350_116678)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3234 16.86H49.538C49.3593 17.1244 49.1544 17.3713 48.9307 17.5965C48.0315 18.4958 46.7908 19.0522 45.4223 19.0522C44.0538 19.0522 42.8132 18.4958 41.9139 17.5965C41.0146 16.6972 40.4582 15.4566 40.4582 14.0881C40.4582 12.7196 41.0146 11.4789 41.9139 10.5797C42.8132 9.68042 44.0538 9.12401 45.4223 9.12401C46.7908 9.12401 48.0329 9.68042 48.9307 10.5797C49.2895 10.9385 49.5903 11.3525 49.8256 11.8073H54.3248C54.4904 11.8073 54.6328 11.7346 54.7345 11.6257C54.2929 9.9579 53.4154 8.46591 52.2299 7.28046C50.4852 5.5357 48.078 4.4563 45.4209 4.4563C42.7638 4.4563 40.3565 5.53715 38.6132 7.28046C36.8685 9.02523 35.7891 11.4324 35.7891 14.0895C35.7891 16.7466 36.8699 19.1539 38.6132 20.8972C40.358 22.6419 42.7652 23.7213 45.4209 23.7213C48.0765 23.7213 50.4852 22.6405 52.2299 20.8972C53.3151 19.812 54.1432 18.4682 54.6139 16.9689C54.5369 16.9021 54.4367 16.86 54.3234 16.86V16.86Z",
    fill: "url(#paint5_linear_13350_116678)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M43.2997 9.91248C43.2997 9.91248 43.2997 9.90231 43.2997 9.89795C43.1632 9.96768 43.031 10.0432 42.9031 10.1246C41.2702 11.1241 40.246 12.8049 39.492 14.7153C38.6887 16.7521 37.926 18.2978 37.127 19.4978C38.2659 21.2353 39.9351 22.598 41.9007 23.349C42.2407 21.4677 42.5036 19.6401 42.707 17.8968C41.5332 17.0557 40.7574 15.6901 40.7342 14.156C40.7066 12.3066 41.7598 10.6984 43.2983 9.91393L43.2997 9.91248Z",
    fill: "url(#paint6_linear_13350_116678)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13350_116678",
    x1: 0.111328,
    y1: 12.0002,
    x2: 54.337,
    y2: 12.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13350_116678",
    x1: 2.91502,
    y1: 6.98118,
    x2: 4.90094,
    y2: 8.9671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13350_116678",
    x1: 17.0641,
    y1: 2.32501,
    x2: 19.5396,
    y2: 4.79906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13350_116678",
    x1: 24.1406,
    y1: 8.3118,
    x2: 28.5047,
    y2: 8.3118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ED1C24",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#ED1C24",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#ED1C24",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ED1C24",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#ED1C24",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1C24",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13350_116678",
    x1: 10.0215,
    y1: 19.8643,
    x2: 14.9521,
    y2: 19.8643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ED1C24",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ED1C24",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ED1C24",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ED1C24",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#ED1C24",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13350_116678",
    x1: 38.3154,
    y1: 6.98119,
    x2: 40.3013,
    y2: 8.96711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_13350_116678",
    x1: 36.3425,
    y1: 14.6485,
    x2: 43.352,
    y2: 16.8596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarAbcLogo);
export default __webpack_public_path__ + "static/media/navbar_abc_logo.398c8b9ccb0ceb25828525e74b493ad3.svg";
export { ForwardRef as ReactComponent };